(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('ipDao', ["http", "defaultListConverter", "sqlQueries", "singleRowConverter", "usersWithIpPerDayConverter", "worldAccessMapConverter", "$q", function (http, defaultListConverter, sqlQueries, singleRowConverter, usersWithIpPerDayConverter, worldAccessMapConverter, $q) {
        return {
            retrieve: function (ipId) {
                return http.get(sqlQueries('entity/geo')).params({ entity_id: ipId }).converter(singleRowConverter);
            },
            usersWithIp: function (columns, ipId) {
                return http.get(sqlQueries('user_with_ip')).params({ ip_id: ipId }).converter(defaultListConverter, { columns: columns });
            },
            usersWithIpPerDay: function (ipId, after, timeColumnName) {
                return http.get(sqlQueries('user_with_ip_per_day')).params({
                    ip_id: ipId,
                    after: after
                }).converter(usersWithIpPerDayConverter, {
                    after: after,
                    timeColumnName: timeColumnName
                });
            },
            worldAccess: function (days, ids) {
                ids = ids || {};
                return http.get(sqlQueries('ip_events')).params({
                    days: days,
                    file_id: ids.fileId,
                    folder_id: ids.folderId,
                    user_id: ids.userId,
                    group_id: ids.groupId
                }).converter(worldAccessMapConverter);
            },
            heatMap: function (days) {
                return http.get(sqlQueries('heat_map')).params({ days: days });
            },
            heatMapRes: function (saas, resolution, failed, args) {
                return http.get(sqlQueries('heat_map_res', null, saas)).params({
                    resolution: resolution,
                    failed: failed || 0
                }).showTotalRows(args.showTotal).pagination(args.offset, args.limit);
            },
            // New query to get values from fast caching table.        
            heatMapResCache: function (saas, failed, resolution) {
                return http.get('/api/v1/get_cache_query').params({
                    module: saas,
                    fail: failed,
                    resolution: resolution
                });
            }
        };
    }]);
}());